export const paths = {
  emailAccounts: {
    manage: '/emailaccounts/manage',
    warmup: '/emailaccounts/warmup',
    orderStatus: '/emailaccounts/dfydomains',
    add: '/emailaccounts/orderstatus/add'
  }
}
